import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { TestResults } from "@/components/hr/TestResults";
import { Card, CardContent } from "@/components/ui/card";

export default function TestResultsPage() {
  const { candidateId } = useParams();
  const navigate = useNavigate();
  const [candidate, setCandidate] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (candidateId) {
      fetchCandidate();
    }
  }, [candidateId]);

  const fetchCandidate = async () => {
    try {
      const { data, error } = await supabase
        .from('candidates')
        .select('*')
        .eq('id', candidateId)
        .single();

      if (error) throw error;
      setCandidate(data);
    } catch (error) {
      console.error('Error fetching candidate:', error);
      navigate('/hr');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate('/hr');
  };

  if (loading) {
    return (
      <Card className="max-w-2xl mx-auto">
        <CardContent className="p-6">
          <div className="text-center">Φόρτωση...</div>
        </CardContent>
      </Card>
    );
  }

  if (!candidate) {
    return (
      <Card className="max-w-2xl mx-auto">
        <CardContent className="p-6">
          <div className="text-center">Δεν βρέθηκε υποψήφιος</div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="container mx-auto py-8">
      <TestResults
        candidateId={candidate.id}
        candidateName={candidate.full_name}
        onClose={handleClose}
      />
    </div>
  );
}